// import { lazy, Suspense} from 'react';
import { lazy, Suspense, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import "bootstrap"; // <-- JS File

/// Components
import Index from "./jsx";
// import { connect } from 'react-redux';
import { connect, useDispatch } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style
import "./vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
import Registration from './jsx/pages/Registration';
import NewPassword from './jsx/pages/NewPassword';
import PhoneOtp from './jsx/pages/PhoneOtp';
import PhonePassword from './jsx/pages/PhonePassword';


const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const Login = lazy(() => {
    return new Promise(resolve => {
        setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
    });
});

const PhoneLogin = lazy(() => {
    return new Promise(resolve => {
        setTimeout(() => resolve(import('./jsx/pages/PhoneLogin')), 500);
    });
});

function App(props) {
    const dispatch = useDispatch();
    useEffect(() => {
        checkAutoLogin(dispatch, props.history);
    }, [dispatch, props.history]);

    let routes = (
        <Switch>
            <Route path='/login' component={Login} />
            <Route path='/phone-login' component={PhoneLogin} />
            <Route path='/register' component={SignUp} />
            <Route path='/forgot-password' component={ForgotPassword} />
            <Route path='/new-password' component={NewPassword} />
            <Route path='/phone-otp' component={PhoneOtp} />
            <Route path='/phone-password' component={PhonePassword} />
           
        </Switch>
    );
    if (props.isAuthenticated) {
        return (
            <>
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }
                >
                    <Index />
                </Suspense>
            </>
        );

    } else {
        return (
            <div className="vh-100">
                <Suspense fallback={
                    <div id="preloader">
                        <div className="sk-three-bounce">
                            <div className="sk-child sk-bounce1"></div>
                            <div className="sk-child sk-bounce2"></div>
                            <div className="sk-child sk-bounce3"></div>
                        </div>
                    </div>
                }
                >
                    {routes}
                </Suspense>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(App));

